/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';

import { custom } from './logo.css';

const ClientLogo = ({ size, small, src }) => {
  const nextSize = small ? 24 : size;
  return <img css={custom} height={nextSize} src={src} alt="" />;
};

ClientLogo.propTypes = {
  size: PropTypes.number,
  small: PropTypes.bool,
  src: PropTypes.string.isRequired,
};
ClientLogo.defaultProps = {
  size: 64,
  small: false,
};

export default ClientLogo;
